import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2, ShieldCheck } from 'lucide-react';

const GOVERNANCE_ROWS = [
  { slug: 'ai_engineering.manage_provider_settings', label: 'Configurar provider/chave' },
  { slug: 'ai_engineering.create', label: 'Criar task' },
  { slug: 'ai_engineering.analyze', label: 'Analyze' },
  { slug: 'ai_engineering.suggest_fix', label: 'Suggest Fix' },
  { slug: 'ai_engineering.apply_sandbox', label: 'Apply to Sandbox' },
  { slug: 'ai_engineering.approve', label: 'Approve' },
];

export const AIEngineeringGovernancePanel = ({ config, auditLogs, loadingAudit }) => (
  <Card className="border-slate-200 shadow-sm" data-testid="ai-engineering-governance-card">
    <CardHeader className="space-y-2 pb-3">
      <CardTitle className="flex items-center gap-2 text-base font-semibold text-slate-950"><ShieldCheck className="h-4 w-4 text-slate-500" /> Governação local</CardTitle>
      <CardDescription className="text-xs text-slate-600">Matriz de permissões do módulo, política de paths/risk/config e trilho de auditoria das alterações de control plane.</CardDescription>
    </CardHeader>

    <CardContent className="space-y-4">
      <div className="rounded-sm border border-slate-200 p-3" data-testid="ai-engineering-permission-matrix-box">
        <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Permissões por acção</p>
        <div className="mt-3 space-y-2">
          {GOVERNANCE_ROWS.map((row) => {
            const allowed = Boolean(config?.permissions?.[row.slug]?.allowed);
            return (
              <div key={row.slug} className="flex items-center justify-between rounded-sm border border-slate-200 bg-slate-50 px-3 py-2 text-sm" data-testid={`ai-engineering-permission-row-${row.slug.replace(/\./g, '-')}`}>
                <div>
                  <p className="font-medium text-slate-900">{row.label}</p>
                  <p className="text-xs text-slate-500">{config?.permissions?.[row.slug]?.description || row.slug}</p>
                </div>
                <Badge variant="outline" className={`rounded-sm ${allowed ? 'border-emerald-200 bg-emerald-50 text-emerald-700' : 'border-slate-300 bg-white text-slate-600'}`}>{allowed ? 'Permitido' : 'Bloqueado'}</Badge>
              </div>
            );
          })}
        </div>
      </div>

      <div className="rounded-sm border border-slate-200 p-3" data-testid="ai-engineering-policy-summary-box">
        <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Política V2 nesta fase</p>
        <div className="mt-3 grid gap-3 md:grid-cols-2">
          <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600" data-testid="ai-engineering-blocked-paths-box">
            <p className="font-medium text-slate-900">Paths bloqueados</p>
            <p className="mt-1">{config?.policy_summary?.blocked_write_paths?.length || 0} padrões hard-blocked</p>
          </div>
          <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600" data-testid="ai-engineering-real-capabilities-box">
            <p className="font-medium text-slate-900">Capacidades reais</p>
            <p className="mt-1">Analyze Real e Suggest Fix Real estão disponíveis; Apply to Sandbox continua OFF</p>
          </div>
        </div>
      </div>

      <div className="rounded-sm border border-slate-200 p-3" data-testid="ai-engineering-config-audit-box">
        <div className="flex items-center justify-between gap-3">
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Auditoria de configuração</p>
          {loadingAudit ? <span className="text-xs text-slate-500">A carregar...</span> : null}
        </div>
        <div className="mt-3 space-y-2">
          {(auditLogs || []).length ? auditLogs.map((log) => (
            <div key={log.id} className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600" data-testid={`ai-engineering-config-audit-item-${log.id}`}>
              <p className="flex items-center gap-2 font-medium text-slate-900"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" /> {log.summary}</p>
              <p className="mt-1">{log.actor_name || 'Utilizador'} • {new Date(log.created_at).toLocaleString('pt-PT')}</p>
            </div>
          )) : <p className="text-xs text-slate-500" data-testid="ai-engineering-config-audit-empty-state">Ainda não existem alterações auditadas neste control plane.</p>}
        </div>
      </div>
    </CardContent>
  </Card>
);